export const normalizePhoneNumber = (input) => {
  if (input == null) {
    return { normalized: "", valid: false };
  }
  
  let s = String(input).normalize("NFKD").trim();
  
  s = s.replace(
    /[\u00A0\u200B-\u200F\u2028\u202F\u2060\u205F\u3000\uFEFF]/g,
    ""
  );
  if (s.includes("+")) {
    return { normalized: "", valid: false };
  }

  s = s
    .replace(/[＋]/g, "+")
    .replace(/[‐-‒–—−]/g, "") // guiones raros
    .replace(/[()]/g, ""); // paréntesis del autofill
  s = s.replace(/[^0-9+]/g, "");
  s = s.replace(/^(\+|00)/, "");

  if (s.startsWith("57") && s.length > 10) {
    s = s.slice(2);
  }

  const valid = /^\d{10}$/.test(s);

  return { normalized: s, valid };
};

export const normalizeNumber = (input) => {
  if (input === null || input === undefined) {
    return { normalized: "", valid: false };
  }
  let s = String(input).trim();
  if (/[a-zA-Z]/.test(s)) {
    return { normalized: "", valid: false };
  }
  if (/[^0-9+\s]/.test(s)) {
    return { normalized: "", valid: false };
  }
  s = s.replace(/^\+/, "");
  s = s.replace(/\s+/g, "");
  s = s.replace(/^00/, "");
  if (s.startsWith("57") && s.length > 10) {
    s = s.slice(2);
  }
  const valid = /^\d{10}$/.test(s);
  return { normalized: s, valid };
};

export const toIsoWithOffset = (date = new Date()) => {
  if (!(date instanceof Date)) date = new Date(date);
  return date.toISOString().replace("Z", "+00:00");
};
